// @core/api/endpoints/document/list_document_policies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListDocumentPoliciesResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List policies
 * Returns document policies, optionally filtered by scope entity type.
 */
export async function ListDocumentPolicies(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListDocumentPoliciesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/document-policies`;
  const requestOptions = options;
  return client.get<ListDocumentPoliciesResponse>(requestPath, { ...requestOptions, params });
}
